export const CITY_MANAGEMENT_START = "CITY_MANAGEMENT_START";
export const CITY_MANAGEMENT_SUCCESS = " CITY_MANAGEMENT_SUCCESS";
export const CITY_MANAGEMENT_ERROR = "CITY_MANAGEMENT_ERROR";

export const CITY_MANAGEMENT_ALL_SUCCESS = "CITY_MANAGEMENT_ALL_SUCCESS";
export const CITY_MANAGEMENT_COMING_SUCCESS = "CITY_MANAGEMENT_COMING_SUCCESS";
export const CITY_MANAGEMENT_POPULAR_SUCCESS =
  "CITY_MANAGEMENT_POPULAR_SUCCESS";

export const ADD_CITY_DATA_START = "ADD_CITY_DATA_START";
export const ADD_CITY_DATA_SUCCESS = "ADD_CITY_DATA_SUCCESS";
export const ADD_CITY_DATA_ERROR = "ADD_CITY_DATA_ERROR";

export const CITY_MANAGEMENT_DETAILS = "CITY_MANAGEMENT_DETAILS";
export const CITY_MANAGEMENT_DETAILS_SUCCESS = "CITY_MANAGEMENT_DETAILS_SUCCESS";
export const CITY_MANAGEMENT_DETAILS_FAIL = "CITY_MANAGEMENT_DETAILS_FAIL"

export const CITY_MANAGEMENT_UPDATE = "CITY_MANAGEMENT_UPDATE";
export const CITY_MANAGEMENT_UPDATE_SUCCESS = "CITY_MANAGEMENT_UPDATE_SUCCESS";
export const CITY_MANAGEMENT_UPDATE_FAIL = "CITY_MANAGEMENT_UPDATE_FAIL";

export const CITY_MANAGEMENT_DELETE = "CITY_MANAGEMENT_DELETE";
export const CITY_MANAGEMENT_DELETE_SUCCESS = "CITY_MANAGEMENT_DELETE_SUCCESS";
export const CITY_MANAGEMENT_DELETE_FAIL = "CITY_MANAGEMENT_DELETE_FAIL";

export const CITY_MANAGEMENT_CSV_START = "CITY_MANAGEMENT_CSV_START";
export const CITY_MANAGEMENT_CSV_SUCCESS = "CITY_MANAGEMENT_CSV_SUCCESS";
export const CITY_MANAGEMENT_CSV_ERROR = "CITY_MANAGEMENT_CSV_ERROR"